









































import Vue from 'vue';
import { VMenu, VBtn } from 'vuetify/lib';

interface Item {
  link: string;
  href: string;
  icon: string;
  image: any;
}

export default Vue.extend({
  components: {
    VMenu,
    VBtn,
    AiIcon: () => import('../AiIcon/AiIcon.vue')
  },
  data() {
    return {
      showMenu: false
    };
  },
  methods: {
    routeTo(item: Item) {
      this.showMenu = false;
      if (item?.href) {
        window.location.href = item.href;
      }

      this.$router.push(item.link).catch(() => {
        //
      });
    }
  },
  props: {
    items: { type: Array, default: () => [] }
    // E.g.
    // items: [
    //   {
    //     title: 'Color',
    //     icon: 'ico-tile-datasets-unselected',
    //     image: require('@/assets/logo.svg'),
    //     link: '/color'
    //   },
    //   { isGroupTitle: true, title: 'Coming Soon' }
    // ]
  }
});
